import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

interface StoreActionMenuProps {
  storeId: string;
  anchorEl: HTMLElement;
  handleClose: () => void;
}

const StoreActionMenu: React.FC<StoreActionMenuProps> = (
  {
    storeId, anchorEl, handleClose,
  },
) => {
  const navigate = useNavigate();

  const handleEditClicked = () => {
    navigate(`/store/?storeId=${storeId}`);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted
      open
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      onClose={handleClose}
    >
      <MenuItem id="edit-store-button" onClick={handleEditClicked}>{'Edit'}</MenuItem>
    </Menu>
  );
};
export default StoreActionMenu;
